export default __webpack_public_path__ + "static/media/presentation.50d41533.pptx";